import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '@/store/cartSlice'
import { servicesSlice } from '@/store/servicesSlice'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'

export const selectTotalGlobalSelectedQuantity = createSelector(
  [
    servicesSlice.selectors.data,
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedElementReservation,
  ],
  (services, cartReservations, selectedElementReservation) => {
    if (!services?.hasLimit) {
      return 0
    }

    const reservations = [
      ...(selectedElementReservation !== null
        ? [selectedElementReservation]
        : []),
      ...cartReservations.filter(
        (res) =>
          `${res.spotName}${res.spotType}` !==
          `${selectedElementReservation?.spotName}${selectedElementReservation?.spotType}`
      ),
    ]
    const ticketServices = services.ticketServices
    const ticketIds = ticketServices.map((service) => service.serviceId)
    return reservations.reduce((total, reservation) => {
      for (const key in reservation?.boughtServices) {
        const serviceId = Number(key)
        if (ticketIds.includes(Number(serviceId))) {
          total += getBoughtServicesTotal(reservation.boughtServices[serviceId])
        }
      }

      return total
    }, 0)
  }
)
